<template>
  <component :is="tag" :title="fullText">
    {{ truncatedText }}
  </component>
</template>

<script>
export default {
  name: 'TextTruncator',
  props: {
    max: {
      type: Number,
      required: true,
    },
    tag: {
      type: String,
      default: 'p',
    },
  },
  computed: {
    fullText() {
      return this.$slots.default
        ? this.$slots.default[0].text.trim()
        : '';
    },
    truncatedText() {
      return this.fullText.length > this.max
        ? this.fullText.slice(0, this.max) + '...'
        : this.fullText;
    },
  },
};
</script>
